import Alpine from 'alpinejs';

Alpine.data('slideshow', (total) => {
  return {
    total,
    current: 0,

    init() {
      this.interval = setInterval(() => {
        this.current = (this.current + 1) % this.total;
      }, 600);
    },
  };
});

Alpine.registerModule('slideshow');
